<script lang="ts" setup>
import { IMarket } from "~/types/sports/market";
import { IOutcome } from "~/types/sports/outcome";
import { isMobile } from "~/utils/constants";
import Outcome from "~/components/layout/TrackRacing/Shared/Outcome/Outcome.vue";

interface OutcomeProps {
	outcome: IOutcome;
	markets: IMarket[];
	eventId: number | undefined;
	isStartingPrice: boolean | undefined;
	showAdditionalInfo: boolean;
	sportId: string;
}
const props = defineProps<OutcomeProps>();

const validatedMarkets = computed(() => props.markets.filter((market) => market.shouldDisplay));

const marketColumns = computed(() => {
	const cols = validatedMarkets.value.map(() => "55px");
	return cols ? cols?.join(" ") : "";
});

const gridClass = computed(() => {
	const gridTemplateCols =
		props.sportId === "greyhounds"
			? `35px 1fr ${marketColumns.value}`
			: isMobile || !props.showAdditionalInfo
			? `25px 45px 1fr ${marketColumns.value}`
			: `25px 45px minmax(50px,1fr) repeat(3, minmax(20px, 70px)) minmax(20px, 150px) ${marketColumns.value}`;
	return `grid-template-columns: ${gridTemplateCols}`;
});
</script>
<template>
	<div @click="(e) => e.stopPropagation()" :style="gridClass" class="items-center min-h-[40px] gap-1 px-1 leading-none grid">
		<Outcome
			:isStartingPrice="isStartingPrice"
			:outcome="outcome"
			:markets="validatedMarkets"
			:selected-event-id="eventId"
			:showAdditionalInfo="showAdditionalInfo"
		/>
	</div>
</template>
